// Import polyfills first to ensure Node.js globals are available
import './polyfills.js';

// Initialize i18next before rendering the app
import './i18n';

// React imports
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Create root using React 18 API
ReactDOM.createRoot(document.getElementById('root')!).render(
  // Suspense is needed for i18next to work with React 18
  <Suspense fallback="Loading...">
    <App />
  </Suspense>
);
